export default "__VITE_ASSET__DSLIbS1d__"